<template>
  <div>
    <v-flex v-if="relatedImages.length > 0" xs12 class="mb-3" style="border: 1px dashed orange">
      <v-card flat>
        <v-card-text class="pr-0 pl-0">
          <h2 class="text-center">{{relatedTitle}}</h2>
          <v-container>
            <v-layout row wrap align-content-center>
              <template v-for="(item, index) in relatedImages">
                <v-flex xs12 sm6 md4 lg3 :key="index" class="mb-2 p-2">
                  <v-card min-height="222">
                    <cld-image
                      :publicId="item.public_id"
                      width="300"
                      height="169"
                      aspectRatio="16:9"
                      crop="thumb"
                      style="width:100%;height:auto;"
                      v-if="item.public_id"
                    />
                    <v-img
                      width="300"
                      height="169"
                      aspect-ratio="1.7777"
                      style="width:100%;height:auto;"
                      :src="item.base64"
                      v-else-if="item.base64"
                    />
                    <v-card-actions>
                      <v-btn icon>
                        <v-icon @click="openImageDialog(item)">mdi-message-outline</v-icon>
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn icon>
                        <v-icon @click="deleteImage(index)">mdi-delete-outline</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-flex>
              </template>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 class="mb-3">
      <v-card flat>
        <v-card-text class="pr-0 pl-0">
          <h2 class="text-center">{{title}}</h2>
          <v-container>
            <v-layout row wrap align-content-center>
              <template v-for="(item, index) in images">
                <v-flex xs12 sm6 md4 lg3 :key="index" class="mb-2 p-2">
                  <v-card min-height="222">
                    <cld-image
                      :publicId="item.public_id"
                      width="300"
                      height="169"
                      aspectRatio="16:9"
                      crop="thumb"
                      style="width:100%;height:auto;"
                      v-if="item.public_id"
                    />
                    <v-img
                      width="300"
                      height="169"
                      aspect-ratio="1.7777"
                      style="width:100%;height:auto;"
                      :src="item.base64"
                      v-else-if="item.base64"
                    />
                    <v-card-actions>
                      <v-btn icon>
                        <v-icon @click="openImageDialog(item)" :color="item.comment == '' ? 'red' : 'primary'">mdi-message-outline</v-icon>
                      </v-btn>
                      <v-spacer v-if="!item.public_id"></v-spacer>
                        <v-progress-linear v-if="!item.public_id" :indeterminate="true"></v-progress-linear>
                      <v-spacer></v-spacer>                      
                      <v-btn icon>
                        <v-icon @click="deleteImage(index)">mdi-delete-outline</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-flex>
              </template>
            </v-layout>
            <v-layout row wrap align-content-center>
              <v-flex sm6 class="text-center">
                <div class="container">
                  <div class="dropbox" v-if="$store.state.online" @click="cameraDialog=true">
                    <p>
                      Ta bilder med kamera
                      <br />
                      <v-icon x-large color="primary" class="mt-3">mdi-camera-outline</v-icon>
                    </p>
                  </div>
                  <div class="dropbox" v-else>
                    <p color="red">
                      <v-icon x-large color="red" class="mt-3">mdi-alert</v-icon>
                      <br />Du er ikke koblet til internett og kan derfor ikke laste opp bilder. <br />For å ta bilder, kan du åpne kamera-appen på din telefon, og laste opp bilder når nettforbindelsen er tilbake.
                    </p>
                  </div>
                </div>
              </v-flex>
              <v-flex sm6>
                <ImageUploaderLocalStorage @new-image="addNewImage" @image-updated="imageUpdated" />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-flex>

    <v-dialog v-model="imageDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Bildebeskrivelse</span>
        </v-card-title>
        <v-card-text>
          <cld-image
            :publicId="selectedImage.public_id"
            width="500"
            crop="thumb"
            style="width:100%;"
          />
          <v-textarea
            box
            label="Kommentar:"
            name="Beskrivelse"
            v-model="selectedImage.comment"
            class="mt-2"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat @click="imageDialog=false">Lagre</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="cameraDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card style="background:black;">
        <Camera v-if="cameraDialog" @new-image="addNewImage" @image-updated="imageUpdated" @close="close" @close-and-open="closeAndOpen" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ImageUploaderLocalStorage from "./ImageUploaderLocalStorage.vue";
import Camera from "./Camera.vue";
import store from '../../store/store';

export default {
  props: {
    images: {
      type: Array,
      required: true
    },
    relatedImages: {
      type: Array,
      required: false,
      default: () => []
    },
    title: {
      type: String,
      required: false,
      default: "Bilder:"
    },
    relatedTitle: {
      type: String,
      required: false,
      default: "Bilder fra innflytting:"
    }
  },
  components: { ImageUploaderLocalStorage, Camera },
  data() {
    return {
      imageDialog: false,
      cameraDialog: false,
      selectedImage: { comment: "" }
    };
  },
  methods: {
    openImageDialog(image) {
      this.selectedImage = image;
      this.imageDialog = true;
    },
    addNewImage(image) {
      this.images.push(image);
      this.$emit("update-fields");
    },
    imageUpdated() {
      this.$emit("update-fields");
      store.commit("saveProtocolToServer", "");
    },
    deleteImage(i) {
      this.images.splice(i, 1);
      this.$emit("update-fields");
      store.commit("saveProtocolToServer", "");
    },
    close() {
      this.cameraDialog = false
    },
    closeAndOpen() {
      this.cameraDialog = false
      setTimeout(() => (this.cameraDialog = true), 200);
    }
  }
};
</script>

<style lang="scss" scoped>
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: transparent;
  color: darkgrey;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.dropbox:hover {
  background-color: rgba(54, 51, 51, 0.3);
}

.dropbox p {
  font-size: 1.4em;
  text-align: center;
  padding: 50px 0;
}
</style>